export default __webpack_public_path__ + "static/media/insppvServicesmortgage.9e642157.svg";